import { StyleSheet } from '@react-pdf/renderer';
import { colors } from '../../theme/colors';

export const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 24,
    marginBottom: 20,
    flex: 1,
  },

  titleContainer: {
    paddingBottom: 10,
  },

  headerItems: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    borderBottom: `1px solid ${colors.neutral}`,
    height: 30,
    minHeight: 30,
    width: '100%',
  },

  headerItem: {
    fontWeight: 800,
    fontSize: 11,
    color: colors.neutral900,
    lineHeight: '1.3px',
    flex: 1,
    textAlign: 'left',
    marginLeft: 8,
  },

  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },

  cell: {
    fontSize: 9,
    marginTop: 11,
    marginBottom: 7,
    color: colors.neutral700,
    fontWeight: 400,
    minHeight: 27,
    flex: 1,
    textAlign: 'left',
    marginLeft: 8,
    textOverflow: 'ellipsis',
  },

  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderBottom: `1px solid ${colors.neutral200}`,
  },

  flexRow: {
    display: 'flex',
    flexDirection: 'row',
  },

  title: {
    fontSize: 16,
    fontWeight: 600,
    backgroundColor: colors.neutral100,
    borderRadius: 6,
    padding: 10,
    marginBottom: 10,
  },

  metadataContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: 40,
    marginBottom: 22,
  },

  metadataTitleItem: {
    color: colors.neutral,
    fontSize: 12,
    fontWeight: 600,
    textTransform: 'uppercase',
    lineHeight: '2px',
    textAlign: 'left',
  },

  metadataItem: {
    color: colors.neutral900,
    fontSize: 14,
    lineHeight: 2,
    fontWeight: 700,
  },

  metadataItemContainer: {
    display: 'flex',
    flexDirection: 'column',
    borderRightWidth: 1,
    borderRightColor: colors.neutral200,
    justifyContent: 'center',
    flex: 1,
    paddingLeft: 20,
  },

  lastMetadata: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 20,
    justifyContent: 'center',
    flex: 1,
  },

  firstMetadata: {
    display: 'flex',
    flexDirection: 'column',
    paddingRight: 20,
    borderRightWidth: 2,
    borderRightColor: colors.neutral200,
    justifyContent: 'center',
    minWidth: '120px',
  },

  poNumber: {
    color: colors.neutral,
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '1px',
  },

  header: {
    color: colors.neutral900,
    fontWeight: 600,
    fontSize: 20,
  },

  sample: {
    color: colors.destructive,
    fontSize: 14,
    lineHeight: '2px',
  },

  additionalLogsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: colors.neutral100,
    height: 17,
    paddingLeft: 2,
  },

  additionalLogs: {
    borderRadius: 3,
    fontSize: 9,
    color: colors.neutral700,
    fontWeight: 400,
    flex: 1,
    textAlign: 'left',
  },
});
